module.exports = __webpack_public_path__ + "img/b1-1.af67c01.png";